module.exports = __webpack_public_path__ + "img/dummy8.64434c0.jpg";